import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CpqFacade } from '../../../../facades/cpq.facade';
import { AddressUtils } from '../../../../utils/address.utils';
import { EAddressType } from '../../../../configurations/common';
import { IAddress } from '../../../../models/common.models';

@Component({
  selector: 'app-cpq-bill-and-payer-address',
  templateUrl: './cpq-bill-and-payer-address.component.html',
  styleUrls: ['./cpq-bill-and-payer-address.component.scss'],
  standalone: false,
})
export class CpqBillAndPayerAddressComponent implements OnInit {
  private formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  private cpqFacade: CpqFacade = inject(CpqFacade);

  reportWrongAddressModalFlag: boolean = false;
  addressesToReport!: IAddress[];
  billToAndPayerAddressForm!: UntypedFormGroup;
  open: boolean = false;
  labelName: string = '';
  typePayer: EAddressType = EAddressType.PAYER;
  typeBillTo: EAddressType = EAddressType.BILL_TO;
  addressType: string = '';
  quoteDocumentGenerationInProgress: boolean = false;

  @Input() billToAddresses!: IAddress[];
  @Input() payerAddresses!: IAddress[];
  @Input() cart: any;
  @Input() cartItemsWithDetails: any;
  @Input() ecommerceTeamEmailAddress!: string;
  @Input() customerBusinessUnitName!: string;
  @Input() functionalLocations!: string[];
  @Output() showAlmostDone: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeReportWrongAddressModal: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.billToAndPayerAddressForm = this.formBuilder.group({
      billToAddress: ['', Validators.required],
      payerAddress: ['', Validators.required],
    });
  }

  closeModals(): void {
    this.closeReportWrongAddressModal.emit(false);
    this.reportWrongAddressModalFlag = false;
  }

  setFormValue(event: any): void {
    this.billToAndPayerAddressForm.patchValue({
      [event.key]: event,
    });
  }

  isFormValid(): boolean {
    return this.billToAndPayerAddressForm?.status === 'VALID';
  }

  submitBillToAndPayerAddress(): void {
    this.quoteDocumentGenerationInProgress = true;
    const body: any = {
      data: {
        type: 'cpq-quote',
        attributes: {
          cartId: this.cart.id,
          customerBillToAddress: AddressUtils.getBodyRequiredAddress(this.billToAndPayerAddressForm.value.billToAddress),
          customerPayerAddress: AddressUtils.getBodyRequiredAddress(this.billToAndPayerAddressForm.value.payerAddress),
        },
      },
    };
    this.cpqFacade.submitGenerateQuoteDocument(body).then(
      () => {
        this.open = true;
        this.showAlmostDone.emit(this.open);
        this.quoteDocumentGenerationInProgress = false;
      },
    );
  }

  showReportWrongAddressModal(addresses: IAddress[], labelName: string, addressType: string): void {
    this.reportWrongAddressModalFlag = true;
    this.addressesToReport = addresses;
    this.labelName = labelName;
    this.addressType = addressType;
  }
}
